// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorBoundary_container__2lPmE","button":"ErrorBoundary_button__1fnLM","placeholderShimmer":"ErrorBoundary_placeholderShimmer__mU4Qj"};